import { gql } from '@apollo/client';

export const getProvidersList = gql`
  query getProviders(
    $pagination: PaginationInput!
    $OrderBy: OrderByInput
    $isCompany: Boolean
    $isLocal: Boolean
    $statuses: [String!]
    $types: [String!]
    $contractStartDateFrom: DateTime
    $contractStartDateTo: DateTime
    $createdOnFrom: DateTime
    $createdOnTo: DateTime
    $keyword: String
  ) {
    salesforce {
      getProviders(
        pagination: $pagination
        orderBy: $OrderBy
        isLocal: $isLocal
        isCompany: $isCompany
        types: $types
        statuses: $statuses
        createdOnFrom: $createdOnFrom
        createdOnTo: $createdOnTo
        contractStartDateFrom: $contractStartDateFrom
        contractStartDateTo: $contractStartDateTo
        keyword: $keyword
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          id
          providerCode
          type {
            title
          }
          isCompany
          isLocal
          personId
          status
          contractStartDate
          contractEndDate
          createdOn
          modifiedOn
          person {
            code
            fullName
            email
            phoneDetails {
              phoneNumber
            }
          }
        }
      }
    }
  }
`;

export const getProviderFilters = gql`
  query {
    salesforce {
      getProviderTypes {
        id
        title
        code
      }
    }
    providerStatusList: __type(name: "ProviderStatusList") {
      enumValues {
        name
      }
    }
  }
`;

export const getProviderById = gql`
  query getProviderById($providerId: String!) {
    salesforce {
      getProviderById(providerId: $providerId) {
        id
        providerCode
        type {
          title
          code
        }
        status
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        personId
        isCompany
        isLocal
        contractStartDate
        contractEndDate
        person {
          code
          fullName
          email
          dateOfBirth
          title
          firstName
          middleName
          lastName
          phoneDetails {
            phoneNumber
            phoneType
          }
          isTaxable
        }
      }
    }
  }
`;
